import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { KeyMessage } from 'generated/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_CRM_KEY_MESSAGES_LAZY = gql`
query GetCRMKeyMessages($filters: KeyMessagesFilter) {
  getCRMKeyMessages(filters: $filters) {
    ID
    BusinessUnit,
    Category,
    Country,
    Description,
    DetailGroupName,
    EndDate,
    Function,
    KeyName,
    MarketAccess,
    Medical,
    Commercial,
    ProductName,
    Sales,
    StartDate,
    Status,
    Type,
    VeevaExternalID,
  }
}
`;

type ResultType = {
  getCRMKeyMessages: KeyMessage[];
};

type UseGetCRMKeyMessagesLazy = () => {
  getCRMKeyMessagesLazy: Function;
  loading: boolean;
  error?: ApolloError;
  data: KeyMessage[];
};

const useGetCRMKeyMessagesLazyQuery: UseGetCRMKeyMessagesLazy = () => {
  const [getCRMKeyMessagesLazy, { data, loading, error }] = useLazyQuery<ResultType>(GET_CRM_KEY_MESSAGES_LAZY, {
    fetchPolicy: 'cache-and-network',
    context: {
      clientName: MAYA_GRAPHQL_ENDPOINT,
      queue: true,
    },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName: 'getCRMKeyMessagesLazy.ts - useGetCRMKeyMessagesLazyQuery',
    });
  }

  return {
    getCRMKeyMessagesLazy,
    data: data?.getCRMKeyMessages || [],
    loading,
    error,
  };
};

export default useGetCRMKeyMessagesLazyQuery;
